var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('loader',{staticClass:"custom-loading mt-4",attrs:{"data-type":"DirectedTreeLoader"}}):_vm._e(),_c('div',{staticClass:"chartdiv",attrs:{"id":"chartdiv"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }